import { Injectable } from '@angular/core';
import { ConvertHelper } from 'app/shared/helpers/convert-helper';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpHeaderModel } from './http-header-model';

@Injectable({
  providedIn: 'root',
})
export class HttpHeaderService {
  private _httpHeader: HttpHeaderModel;
  private _onHttpHeaderChanged: BehaviorSubject<HttpHeaderModel | null> | null;
  private _previousCustomerAreaMessageEtag: number | null | undefined;
  private _previousLaboratoryAreaMessageEtag: number | null | undefined;

  public constructor() {
    this._onHttpHeaderChanged = new BehaviorSubject<HttpHeaderModel | null>(null);
  }

  public get onHttpHeaderChanged(): Observable<HttpHeaderModel | null> {
    return this._onHttpHeaderChanged!.asObservable();
  }

  public getHttpHeader(): HttpHeaderModel {
    return this._httpHeader;
  }

  public setHttpHeaderInfo(customerAreaMessageEtag: string | null | undefined, laboratoryAreaMessageEtag: string | null | undefined): void {
    const customerAreaMessageEtagNumber = ConvertHelper.toNumber(customerAreaMessageEtag);
    const laboratoryAreaMessageEtagNumber = ConvertHelper.toNumber(laboratoryAreaMessageEtag);
    const hasChangedFlag =
      customerAreaMessageEtagNumber !== this._previousCustomerAreaMessageEtag ||
      laboratoryAreaMessageEtagNumber !== this._previousLaboratoryAreaMessageEtag;

    if (!this._httpHeader || hasChangedFlag) {
      this._httpHeader = new HttpHeaderModel(
        customerAreaMessageEtagNumber,
        laboratoryAreaMessageEtagNumber,
        this._previousCustomerAreaMessageEtag,
        this._previousLaboratoryAreaMessageEtag,
      );

      this._previousCustomerAreaMessageEtag = customerAreaMessageEtagNumber;
      this._previousLaboratoryAreaMessageEtag = laboratoryAreaMessageEtagNumber;

      this._onHttpHeaderChanged!.next(this._httpHeader);
    }
  }
}
